import { c as _c } from "react/compiler-runtime";
import { Button } from '@algoacademy/design-system/web/actions/Button';
import { showTrpcMutationErrorToast } from '@algoacademy/design-system/web/feedback/Toaster/ToasterError';
import { TrashIcon } from '@heroicons/react/24/solid';
import { useMutation } from '@tanstack/react-query';
import { useTRPC } from '@/app/_trpc/config';
export type ManagePublishingButtonsProps = {
  jobOfferIsActive?: boolean;
  jobOfferId?: string;
};
export function ManagePublishingButtons(t0) {
  const $ = _c(9);
  const {
    jobOfferIsActive: t1,
    jobOfferId
  } = t0;
  const jobOfferIsActive = t1 === undefined ? false : t1;
  const trpc = useTRPC();
  let t2;
  if ($[0] !== trpc.career.publishJobOffer) {
    t2 = trpc.career.publishJobOffer.mutationOptions();
    $[0] = trpc.career.publishJobOffer;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const publishJobOfferMutation = useMutation(t2);
  let t3;
  if ($[2] !== trpc.career.unpublishJobOffer) {
    t3 = trpc.career.unpublishJobOffer.mutationOptions();
    $[2] = trpc.career.unpublishJobOffer;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const unpublishJobOfferMutation = useMutation(t3);
  if (jobOfferId === undefined) {
    return null;
  }
  let t4;
  if ($[4] !== jobOfferId || $[5] !== jobOfferIsActive || $[6] !== publishJobOfferMutation || $[7] !== unpublishJobOfferMutation) {
    t4 = <>{jobOfferIsActive ? <Button color="destructive" onClick={async () => {
        ;
        try {
          await unpublishJobOfferMutation.mutateAsync({
            id: jobOfferId
          });
        } catch (t5) {
          const error = t5;
          showTrpcMutationErrorToast(error);
        }
      }}><TrashIcon className="size-4" />Archiwizuj ofertę</Button> : <Button onClick={async () => {
        ;
        try {
          await publishJobOfferMutation.mutateAsync({
            id: jobOfferId
          });
        } catch (t6) {
          const error_0 = t6;
          showTrpcMutationErrorToast(error_0);
        }
      }}>Opublikuj ofertę</Button>}</>;
    $[4] = jobOfferId;
    $[5] = jobOfferIsActive;
    $[6] = publishJobOfferMutation;
    $[7] = unpublishJobOfferMutation;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}